import { IToggleable } from '../../models/toggleable.model';
import { UserService } from '../../services/user/user.service';

export function productSegmentToggleFilter<T extends IToggleable>(
  userService: UserService,
  input: T[]
): T[] {
  return input.filter(
    t =>
      t.requiredSegment === null ||
      userService.userHasSegment(t.requiredSegment)
  ) as T[];
}
